"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var PartnersModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnersModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_slicksort_1 = require("vue-slicksort");
const debounce_1 = __importDefault(require("lodash/debounce"));
const backoffice_1 = require("../../dsl/backoffice");
const services_1 = require("../../services");
const form_1 = require("../_abstract/form");
const _contracts_1 = require("../_contracts");
const Image_contracts_1 = require("../Image/Image.contracts");
const validate_js_1 = require("validate.js");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let PartnersModuleForm = PartnersModuleForm_1 = class PartnersModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        this.DashmixIconName = backoffice_1.DashmixIconName;
        this.hasExternalLink = false;
        this.defaultHeight = 32;
        this.img = null;
        this.imgCaption = '';
        this.moduleModes = _contracts_1.ModuleMode;
        this.variants = Image_contracts_1.ImageSelectionOptions;
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = PartnersModuleForm_1.getInitialContent();
        /**
         * The very same content as in `this._content`,
         * but with all related data resolved and ready to use.
         */
        this.resolvedPartners = [];
        this.variant = Image_contracts_1.ImageSelectionOptions.Default;
        /**
         * Sets the value of the `label` property in the given `Partner`.
         *
         * @param index - The array index of the `Partner` object to update.
         * @param label - New value for the `label` property.
         *
         * @see TeaserBoxModuleForm.debouncedFunc
         */
        this.setPartnerLabel = null;
    }
    get hasRelatedLink() {
        if (!this._content.redirect) {
            return false;
        }
        return services_1.isRelated(this._content.redirect);
    }
    description(related) {
        if (!this.descriptions[related.type]) {
            return '';
        }
        return this.descriptions[related.type][related.value] || '';
    }
    /**
     * Resolves the image source from the `Media` picker.
     *
     * @param index - The array index of the `Partner` object to update.
     *
     * @see ImageModuleForm.findImageSource()
     */
    findImageSource(index) {
        this.pickRelated(services_1.Picker.Media, (source) => {
            this.setImageSource(index, source);
        });
    }
    hasImage() {
        return !!this._content.image && typeof this._content.image.value !== 'undefined';
    }
    findLinkSource() {
        this.pickRelated(services_1.Picker.Content, this.setLinkSource);
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.Partners,
            size: {
                colSpan: 6,
                rowSpan: 1,
                isResizable: false,
                minColSpan: 6,
                minRowSpan: 1,
                maxColSpan: 6
            }
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialContent() {
        return {
            backgroundColor: _contracts_1.ModuleBackgroundColor.None,
            background: null,
            partners: []
        };
    }
    findImageRelated() {
        if (typeof this._content.image === 'undefined' || !this.hasImage()) {
            return;
        }
        const related = this.relatedService.resolve(this._content.image, {});
        if (!validate_js_1.isPromise(related)) {
            return;
        }
        related.then((related) => {
            if (Object.prototype.hasOwnProperty.call(related, 'caption')) {
                this.imgCaption = related.caption;
            }
            if (Object.prototype.hasOwnProperty.call(related, 'file')) {
                this.img = {
                    type: related.file.type,
                    thumbnail: related.url
                };
            }
            else if (Object.prototype.hasOwnProperty.call(related, 'url')) {
                this.img = {
                    type: backoffice_1.ImageType.JPG,
                    thumbnail: related.url
                };
            }
        }).catch(error => {
            console.debug(error);
        });
    }
    /**
     * Determines whether the image of a passed-in index exists in the partner of the passed-in index.
     *
     * @param partnerIndex - The array index of the `Partner` object.
     * @param imageIndex - The array index of the image to check.
     */
    isImageResolved(partnerIndex, imageIndex) {
        if (!Array.isArray(this.resolvedPartners) || this.resolvedPartners.length === 0) {
            return false;
        }
        const resolvedPartner = this.resolvedPartners[partnerIndex];
        if (typeof resolvedPartner === 'undefined' ||
            typeof resolvedPartner.images === 'undefined' ||
            !Array.isArray(resolvedPartner.images)) {
            return false;
        }
        const resolvedImage = resolvedPartner.images[imageIndex];
        return typeof resolvedImage !== 'undefined' &&
            typeof resolvedImage.image !== 'undefined' &&
            typeof resolvedImage.image.thumbnail === 'string';
    }
    /**
     * Handles the `@click` event on the "add new image" button.
     *
     * @param index - The array index of the `Partner` object to update.
     */
    onAddNewImageBtnClick(index) {
        this.findImageSource(index);
    }
    /**
     * Handles the `@click` event on the "add new partner" button.
     */
    onAddNewPartnerBtnClick() {
        this.addNewPartner();
    }
    setLinkSource(source) {
        if (this._content.redirect) {
            this._content.redirect = source;
        }
        else {
            this._content = {
                ...this._content,
                redirect: source
            };
        }
        this.$nextTick(() => {
            this.describe(source);
        });
    }
    /**
     * Adds new partner to the partners array.
     */
    addNewPartner() {
        this._content.partners = [...this._content.partners, {
                label: '',
                hasExternalLink: false,
                images: [],
                scales: []
            }];
    }
    deleteImage(imageIndex, partnerIndex) {
        const content = { ...this._content };
        const partner = content.partners[partnerIndex];
        partner.images = [...partner.images];
        partner.images.splice(imageIndex, 1);
        if (partner.scales && partner.scales[imageIndex]) {
            partner.scales.splice(imageIndex, 1);
        }
        this._content = content;
    }
    deletePartner(index) {
        const partnersCopy = [...this._content.partners];
        partnersCopy.splice(index, 1);
        this._content.partners = partnersCopy;
    }
    deleteLinkSource() {
        if (!this._content.redirect) {
            return;
        }
        const contentCopy = { ...this._content };
        delete contentCopy.redirect;
        this._content = contentCopy;
    }
    /**
     * Resolves the related data for the objects inside `this._content.partners` array.
     */
    async resolvePartners() {
        const partnersToResolve = Array.isArray(this._content.partners) ? this._content.partners : [];
        try {
            await Promise.all(partnersToResolve.map((partner, index) => {
                return new Promise((resolve, reject) => {
                    this.resolveSinglePartner(partner)
                        .then(resolvedPartner => {
                        if (Array.isArray(resolvedPartner.images) && resolvedPartner.images.length > 0) {
                            this.resolvedPartners[index] = resolvedPartner;
                            this.resolvedPartners = this._content.partners.map((_partner, _index) => (_index === index ? resolvedPartner : this.resolvedPartners[_index]));
                        }
                        resolve();
                    })
                        .catch(e => {
                        console.warn(e);
                        reject(e);
                    });
                });
            }));
        }
        catch (e) {
            console.warn(e);
        }
    }
    /**
     * Resolves the data of a single `Partner`.
     *
     * @param relatedPartner - The `Partner` which data is to be resolved.
     */
    async resolveSinglePartner(relatedPartner) {
        // Create the base object.
        const partner = {
            label: relatedPartner.label,
            images: []
        };
        // Wait for the `RelatedService` to resolve all the images.
        await Promise.all(relatedPartner.images.map(image => {
            return new Promise((resolve, reject) => {
                this.relatedService.resolve(image, {})
                    .then(resolvedImage => {
                    partner.images = [...partner.images, {
                            caption: resolvedImage.caption,
                            image: { thumbnail: resolvedImage.url }
                        }];
                    resolve();
                })
                    .catch(e => {
                    console.warn(e);
                    reject(e);
                });
            });
        }));
        // Return the populated object.
        return partner;
    }
    setActiveVariant(related) {
        switch (related.value) {
            case '##IMAGE_ID##':
                this.variant = Image_contracts_1.ImageSelectionOptions.Smart;
                break;
            case -1:
                this.variant = Image_contracts_1.ImageSelectionOptions.Smart;
                break;
            default:
                this.variant = Image_contracts_1.ImageSelectionOptions.Default;
        }
    }
    /**
     * Sets the image selected from the `Media` picker.
     *
     * @param index - The array index of the `Partner` object to update.
     * @param source - The source of the selected image.
     *
     * @see ImageModuleForm.setImageSource()
     */
    setImageSource(index, source) {
        const content = { ...this._content };
        const partner = content.partners[index];
        partner.images = [...partner.images, source];
        this._content = { ...content };
        this.resolvePartners();
        // TODO: Resolve only the current image.
        // this.resolveSinglePartner(partner).then(resolvedPartner => {
        //   this.resolvedPartners = this.resolvedPartners.map((_partner, _index) => (
        //     _index === index ? resolvedPartner : _partner
        //   ))
        // })
    }
};
PartnersModuleForm = PartnersModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'PartnersModuleForm',
        components: {
            DashmixButton: backoffice_1.DashmixButton,
            DashmixCheck: backoffice_1.DashmixCheck,
            DashmixSelect: backoffice_1.DashmixSelect,
            DashmixFile: backoffice_1.DashmixFile,
            DashmixInput: backoffice_1.DashmixInput,
            SlickList: vue_slicksort_1.SlickList,
            SlickItem: vue_slicksort_1.SlickItem
        },
        created() {
            const content = this._content;
            content.partners = this._content.partners.map((partner) => {
                return {
                    ...partner,
                    scales: partner.images.map((image, index) => {
                        return partner.scales && partner.scales[index] ? partner.scales[index] : '1';
                    })
                };
            });
            this._content = content;
            this.setPartnerLabel = debounce_1.default((index, label) => {
                if (this.setPartnerLabel === null) {
                    return;
                }
                this.setPartnerLabel.cancel();
                const content = { ...this._content };
                content.partners[index].label = label;
                this._content = content;
            }, 500);
            this.resolvePartners();
        },
        mounted() {
            if (this._content.image) {
                this.setActiveVariant(this._content.image);
            }
            if (this._content.imageType === this.variants.Smart && this.mode === this.moduleModes.Smart) {
                return;
            }
            this.hasExternalLink = !!(this._content.redirectExt && typeof this._content.redirectExt === 'string');
            this.$nextTick(() => {
                this.findImageRelated();
                if (this._content.redirect) {
                    this.describe(this._content.redirect);
                }
            });
        },
        template: `
    <div class="partners-module-form">

    <!-- Partners -->
    <SlickList :value="_content.partners" v-model="_content.partners"
               axis="y" lockAxis="y" tag="ol" :distance="50"
               class="draggable__list p-0 list-unstyled" appendTo=".draggable__list"
               helperClass="shadow">

      <!-- Single partner -->
      <SlickItem v-for="(partner, partnerIndex) in _content.partners" :key="partnerIndex"
                 :index="partnerIndex" tag="li" class="bg-light p-3 mb-3">

        <div class="container">
          <div class="row">
            <!-- Label -->
            <div class="d-flex justify-content-between col-12">
              <div class="form-group col-12 col-md-6">
                <label :for="'partner-' + partnerIndex + '__label'">
                  {{ $t('forms.partners.partner.label') }}
                </label>
                <DashmixInput :model="partner.label" @update:model="setPartnerLabel(partnerIndex, $event)"
                              :name="'partner-' + partnerIndex + '__label'"/>
              </div>
              <div>
                <DashmixButton class="d-flex" size="small" variant="icon" :icon="DashmixIconName.TrashSolid"
                               theme="danger"
                               @click="deletePartner(partnerIndex)"/>
              </div>
            </div>
            <!-- END | Label -->

            <!-- Images -->
            <div class="form-group col-12">
              <label class="d-block">{{ $t('forms.partners.partner.images') }}</label>

              <SlickList :value="partner.images" v-model="partner.images"
                         axis="xy" tag="ol" :distance="50"
                         class="draggable__list p-0 row list-unstyled" appendTo=".draggable__list"
                         helperClass="draggable__list__helper">

                <!-- Single image -->
                <SlickItem v-for="(image, imageIndex) in partner.images"
                           :key="partnerIndex + '-' + imageIndex + '-' + image.value"
                           :index="imageIndex" tag="li" class="col-12 col-md-6">
                  <figure v-if="isImageResolved(partnerIndex, imageIndex)"
                          class="bg-body p-3 figure-with-btn__image-container mt-4">
                    <DashmixInput v-if="partner.scales" :model.sync="partner.scales[imageIndex]"
                                  type="range" min="0" max="3" step="0.01"/>
                    <DashmixFile :file="resolvedPartners[partnerIndex].images[imageIndex].image"
                                 :height="defaultHeight*partner.scales[imageIndex]"
                                 :draggable="false" class="mb-3"/>
                    <DashmixButton class="figure-with-btn__delete-btn"
                                   size="small" variant="icon" :icon="DashmixIconName.TrashSolid" theme="danger"
                                   @click="deleteImage(imageIndex, partnerIndex)"/>
                    <figcaption>{{ resolvedPartners[partnerIndex].images[imageIndex].caption }}</figcaption>
                  </figure>
                </SlickItem>
                <!-- END | Single image -->

              </SlickList>

              <!-- "Add new image" button -->
              <DashmixButton variant="icon" :icon="DashmixIconName.PlusSolid"
                             :label="$t('forms.partners.partner.add-new-image')"
                             @click="onAddNewImageBtnClick(partnerIndex)"/>

              <div class="col-12 mt-2" v-if="partner.images.length > 0">
                <DashmixCheck class="pb-3" :label="$t('forms.image.hasExternalLink')"
                              :name="'hasExternalLink-' + partnerIndex"
                              :model.sync="partner.hasExternalLink"/>

                <template v-if="!partner.hasExternalLink">
                  <DashmixButton v-if="!hasRelatedLink" variant="alt" :icon="DashmixIconName.SearchSolid"
                                 :label="$t('forms.shared.search')"
                                 @click="findLinkSource"/>

                  <div class="row" v-else>
                    <div class="col d-flex align-items-center">
                      <p class="mb-0">
                        <strong class="mr-2">{{ $t('forms.shared.chosenSource') }}</strong>
                        {{ description(_content.redirect) }}
                      </p>
                    </div>
                    <div class="col-3 d-flex text-right">
                      <DashmixButton variant="icon" :icon="DashmixIconName.PenSolid"
                                     @click="findLinkSource"/>
                      <DashmixButton theme="danger" variant="icon"
                                     :icon="DashmixIconName.TrashSolid"
                                     @click="deleteLinkSource"/>
                    </div>
                  </div>
                </template>

                <template v-else>
                  <div class="form-group">
                    <label for="urlPath" class="d-block">{{ $t('forms.image.path.label') }}</label>
                    <DashmixInput :model.sync="partner.urlPath" name="urlPath"
                                  :placeholder="$t('forms.image.path.placeholder')"/>
                  </div>
                </template>
                <div>
                </div>
              </div>
            </div>
            <!-- END | Images -->
          </div>
        </div>

      </SlickItem>
      <!-- END | Single partner -->

    </SlickList>
    <!-- END | Partners -->

    <div class="form-group col-12 col-md-6">
      <label for="color">{{ $t('forms.shared.backgroundColor') }}</label>
      <DashmixSelect :model.sync="_content.backgroundColor" name="backgroundColor"
                     :placeholder="$t('forms.shared.backgroundColorPlaceholder')"
                     :options="backgroundColorOptions" :searchable="false"/>
      <DashmixInput v-if="isCustomColor" type="color" :model.sync="_content.background" name="background"/>
    </div>
    <!-- "Add new partner" button -->
    <DashmixButton variant="icon" :icon="DashmixIconName.PlusSolid"
                   :label="$t('forms.partners.add-new-partner')" @click="onAddNewPartnerBtnClick"/>

    </div>
  `
    })
], PartnersModuleForm);
exports.PartnersModuleForm = PartnersModuleForm;
//# sourceMappingURL=Partners.form.js.map